const ru = {
  app: {
    name: "Калькулятор точки начала снижения",
    shortName: "Калькулятор T/D",
    subtitle: "Инструмент приблизительного планирования снижения",
    badge: "Frontend-калькулятор",
    disclaimer:
      "Этот калькулятор предназначен только для учебного и приблизительного планирования. Он не сертифицирован для эксплуатационного использования в авиации.",
  },
  language: {
    label: "Язык",
    uzbek: "O'zbek",
    russian: "Русский",
    english: "English",
  },
  nav: {
    calculator: "Калькулятор",
    results: "Результаты",
    info: "Информация",
  },
  form: {
    title: "Параметры снижения",
    altitudeSection: "Высота",
    speedSection: "Скорость и ветер",
    profileSection: "Профиль",
    startAltitude: "Начальная высота",
    endAltitude: "Конечная высота",
    groundSpeed: "Путевая скорость",
    finalSpeed: "Конечная скорость",
    wind: "Ветер",
    glideSlope: "Угол глиссады",
    verticalSpeed: "Вертикальная скорость",
    startAltitudePlaceholder: "Например: 30 000",
    endAltitudePlaceholder: "Например: 10 000",
    groundSpeedPlaceholder: "Например: 320",
    finalSpeedPlaceholder: "Например: 250",
    windPlaceholder: "Например: 0",
    glideSlopePlaceholder: "Например: 3",
    verticalSpeedPlaceholder: "Например: 1 500",
    calculate: "Рассчитать",
    reset: "Очистить",
    fillExample: "Заполнить пример",
    helperProfile:
      "Глиссада и вертикальная скорость связаны — изменение одного значения обновляет другое.",
  },
  units: {
    feet: "ft",
    knots: "kts",
    degrees: "°",
    fpm: "fpm",
    nauticalMiles: "NM",
    minutes: "мин",
  },
  results: {
    title: "Расчётные результаты",
    empty: "Введите значения, чтобы увидеть результаты.",
    verticalSpeed: "Вертикальная скорость",
    topOfDescent: "Точка начала снижения",
    estimatedTime: "Расчётное время",
    approximate: "Приблизительный расчёт",
  },
  info: {
    title: "Информация о расчёте",
    howItWorks: "Как это работает",
    description:
      "Расстояние до точки начала снижения рассчитывается на основе разницы высот, угла глиссады и средней путевой скорости. Изменение скорости и поправка на ветер применяются как дополнительные факторы.",
    formulaLabel: "Основная формула",
    formula:
      "расстояние = разница высот × tan(глиссада) × коэффициент скорости",
    safetyTitle: "Только для обучения и планирования",
    safetyText:
      "В реальном полёте приоритет имеют тип воздушного судна, профиль полёта, атмосферные условия, указания ATC и официальные навигационные данные.",
  },
  validation: {
    required: "Это поле обязательно.",
    invalidNumber: "Введите корректное число.",
    invalidAltitude: "Конечная высота должна быть ниже начальной высоты.",
    startAltitudeTooLow:
      "Начальная высота должна быть выше конечной высоты.",
    invalidSpeed: "Скорость должна быть положительным значением.",
    invalidGlideSlope: "Угол глиссады должен быть больше 0.",
    invalidVerticalSpeed:
      "Вертикальная скорость должна быть положительным значением.",
  },
  footer: {
    text: "Калькулятор T/D · Инструмент приблизительного планирования снижения",
    version: "Версия",
  },
  status: {
    ready: "Готово",
    calculating: "Выполняется расчёт",
    invalid: "Проверьте данные",
  },
};

export default ru;
